(function () {
  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function roundUpToMultiple(val, step) {
    if (step <= 1) return val;
    var r = val % step;
    return r === 0 ? val : val + (step - r);
  }

  function normalizeQtyInput(input) {
    if (!input) return;

    var step = toInt(input.getAttribute('step'), 1);
    if (!step || step < 1) step = 1;

    var min = toInt(input.getAttribute('min'), step);
    if (!min || min < 1) min = step;

    var val = toInt(input.value, min);
    if (!val || val < min) val = min;

    input.value = String(roundUpToMultiple(val, step));
  }

  // Normalize when user leaves the field
  document.addEventListener(
    'blur',
    function (e) {
      var input = e.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.name !== 'quantity') return;
      normalizeQtyInput(input);
    },
    true
  );

  // Normalize BEFORE the theme’s + / - handlers run
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;

      // Empire commonly uses name="plus"/"minus" OR data attributes
      var isPlus =
        btn.getAttribute('name') === 'plus' ||
        btn.matches('[data-qty-increase], [data-plus], .quantity__button[name="plus"]');

      var isMinus =
        btn.getAttribute('name') === 'minus' ||
        btn.matches('[data-qty-decrease], [data-minus], .quantity__button[name="minus"]');

      if (!isPlus && !isMinus) return;

      var wrapper = btn.closest('.quantity, .product-quantity, .product-form__quantity, [data-quantity-wrapper]') || document;
      var input = wrapper.querySelector('input[name="quantity"]');
      if (!input) return;

      // Normalize current value so 2 becomes 3 before adding step 3
      normalizeQtyInput(input);

      // Also enforce min on minus clicks
      if (isMinus) {
        var min = toInt(input.getAttribute('min'), 1);
        var val = toInt(input.value, min);
        if (val < min) input.value = String(min);
      }
    },
    true // capture = run first
  );
})();